import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class UnavailabilityModel extends Vue {

    @Prop() staffAvailabilityId!: number;
    @Prop() staffId!: number;
    @Prop() tenantId!: string;
    @Prop() startDate!: Date;
    @Prop() endDate!: Date;
    @Prop() isUnavailable!: boolean;
}